export default [
    {
        // [0]
        key: "code",
        label: "Personal",
        visible: true,
    },
    {
        // [1]
        key: "is_viatic",
        label: "Viatic",
        visible: true,
    },
    {
        // [2]
        key: "entity_group_name",
        label: "Sub Group",
        visible: true,
    },
    {
        // [3]
        key: "dl_count",
        label: "DL",
        visible: true,
    },
    {
        // [4]
        key: "fa_count",
        label: "FA",
        visible: true,
    },
    {
        // [5]
        key: "ps_count",
        label: "PS",
        visible: true,
    },
    {
        // [6]
        key: "to_day_hour",
        label: "Today",
        visible: true,
    },
    {
        // [7]
        key: "observation",
        label: "Observation",
        visible: true,
    },
    {
        // [8]
        key: "id",
        label: "Actions",
        visible: true,
        tdClass:"text-center",
        thClass:"text-center"

    },
]